var map = {
	"./1 Thumbnail, title_ OPERASI TES URINE BNNK, LIMA PENGENDARA POSITIF.jpeg": 39836,
	"./2 Thumbnail, title_ Pertama di Pulau Kalimantan, Kepala BNN RI Luncurkan Kampus Bersinar di UNMUL.jpeg": 70358,
	"./3 Thumbnail, title_ BNN Edukasi Bahaya Narkoba pada Pengunjung Kalteng Trade Expo 2018.jpg": 31106,
	"./4 Thumbnail, title_ BNN-KASN Siapkan Pengawasan Narkoba di Kalangan ASN.jpg": 39182,
	"./5 Thumbnail, title_ Setjen DPR dan BNN Gelar Sosialisasi Bahaya Narkotika kepada ASN Kesetjenan.jpg": 28369,
	"./6 Thumbnail, title_ Studi Eksekursi dalam rangka mendukung Penyusunan Juknis Pemberdayaan Alternatif.jpg": 90407,
	"./7 Thumbnail, title_ BNN RI Bentengi Masyarakat Pada Kawasan Narkoba melalui Bimbingan Teknis Life Skill.jpg": 85704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68768;